import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Textfit } from 'react-textfit';

export default function MultipleChoice({ currentQuestion, ...props }) {
  return (
    <>
      <Container>
        <div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Question
            type="text"
            disabled
            value={
              currentQuestion.question !== undefined
                ? currentQuestion.question.replace("$", "?")
                : ""
            }
          >
             <Textfit mode="multi" max="50" style={{ height: "100%" }}><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question) }} />}</span></Textfit></Question>
          {props.playAudio && (
            <Button
              style={{
                alignSelf: "center",
                width: "100px",
                height: "100px",
                borderRadius: "50px",
                lineHeight: "70px",
                fontSize: "3em"
              }}
              onClick={() => props.saySentence()}
            >
              <span>Say</span>
            </Button>
          )}
        </div>
          {currentQuestion.question2 !== undefined && currentQuestion.question2 !=="" ?
          <Question
            type="text"
            disabled
            value={
              currentQuestion.question2 !== undefined
                ? currentQuestion.question2.replace("$", "?")
                : ""
            }
            ><Textfit mode="multi" max="40" style={{ height: "100%" }}><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question2) }} />}</span></Textfit></Question>
          : ""}
        </div>
        {props.playAudio && (
          <Button
            style={{
              alignSelf: "center",
              width: "100px",
              height: "100px",
              borderRadius: "50px",
              lineHeight: "50px"
            }}
            onClick={() => props.replay()}
          >
            <span>?</span>
          </Button>
        )}
        {props.onShowFeedback == false && currentQuestion.answers !== undefined ? (<div>
            {currentQuestion.answers[0].value.toString().length < 10 || currentQuestion.answers[0].value.toString().includes("</sub>") == true ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
          }}
        >
          {
            currentQuestion.answers.map(answer => (
              <Button
                value={answer.value}
                style={{ flex: 1, margin: "20px" }}
                onClick={() => props.onSubmit(answer, currentQuestion)}
              >
                <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
              </Button>
            ))}
            </div>):(
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
          }}
        >
          {props.onShowFeedback == false && currentQuestion.answers !== undefined &&
            currentQuestion.answers.map(answer => (
              <LongButton
                value={answer.value}
                style={{ alignSelf: "center", flex: 1, margin: "20px" }}
                onClick={() => props.onSubmit(answer, currentQuestion)}
              >
                <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
              </LongButton>
            ))}
            </div>)}</div>):""}

            {props.onShowFeedback == true && currentQuestion.answers !== undefined ? (<div>
            {currentQuestion.answers[0].value.toString().length < 10 || currentQuestion.answers[0].value.toString().includes("</sub>") == true ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
          }}
        >
          {
            currentQuestion.answers.map(answer => (
              <Button
                value={answer.value}
                style={{ flex: 1, margin: "20px" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
              >
                <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
              </Button>
            ))}
            </div>):(
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
          }}
        >
          {props.onShowFeedback == true && currentQuestion.answers !== undefined &&
            currentQuestion.answers.map(answer => (
              <LongButton
                value={answer.value}
                style={{ alignSelf: "center", flex: 1, margin: "20px" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
              >
                <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
              </LongButton>
            ))}
            </div>)}</div>):""}

      </Container>
    </>
  );
}

const Container = styled.div`
width:80%;
height:95%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom:100px;
`;

const Question = styled.div`
  background: #FFF;
  user-select: none;
  width: 100%;
  height: 120px;
  line-height: 90px;
  font-size: 4em;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
`;

const Button = styled.div`
  overflow: clip;
  text-align: center;
  width: 10%;
  height: 150px;
  line-height: 100px;
  font-size: 3.5em;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const LongButton = styled.div`
  text-align: center;
  width: 80%;
  height: 100px;
  line-height: 50px;
  font-size: 4em;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;